<blockquote class="flex flex-wrap justify-center my-8 ~text-2xl/3xl">
    <span class="text-primary ~text-2xl/4xl">&ldquo;</span>
    <span class="text-nowrap">{{ "shop.theBestFromYard" | translate }}</span>
    <span class="text-nowrap"
        >&#160;{{ "shop.directlyToYourHome" | translate }}</span
    >
    <span class="text-primary ~text-2xl/4xl">&ldquo;</span>
</blockquote>
<div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 lg:grid-rows-[min-content,1fr] ~gap-2/8 ~pb-12/24"
>
    <!-- filter by -->
    <div
        class="top-0 lg:top-28 relative lg:sticky self-start lg:row-span-2 overflow-visible"
    >
        <button
            type="button"
            class="hs-collapse-toggle inline-flex justify-between items-center gap-x-2 bg-[#fff] hover:bg-gray-200 focus:bg-gray-200 px-4 py-3 border border-primary rounded-lg focus:outline-hidden w-full font-medium lg:~mb-2/8"
            id="hs-basic-collapse"
            aria-expanded="false"
            aria-controls="hs-basic-collapse-heading"
            data-hs-collapse="#hs-basic-collapse-heading"
        >
            {{ "shop.filterBy" | translate }}
            <svg
                class="lg:hidden size-4 text-black hs-collapse-open:rotate-180 shrink-0"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="m6 9 6 6 6-6"></path>
            </svg>
        </button>

        <!-- Filters Section -->
        <div
            id="hs-basic-collapse-heading"
            class="hidden hs-collapse hs-collapse z-10 absolute lg:relative lg:flex flex-col gap-6 bg-gray-50 p-4 rounded-lg w-full h-fit overflow-hidden transition-[height] duration-300"
            aria-labelledby="hs-basic-collapse"
            [attr.data-aos]="domHandler.isDesktop ? 'fade-right' : undefined"
            [attr.data-aos-delay]="domHandler.isDesktop ? '200' : undefined"
        >
            <!-- Search Input -->
            <div class="relative">
                <div
                    class="left-0 absolute inset-y-0 flex items-center pl-3 pointer-events-none"
                >
                    <svg
                        class="w-4 h-4 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <circle cx="11" cy="11" r="8"></circle>
                        <path d="m21 21-4.3-4.3"></path>
                    </svg>
                </div>
                <input
                    type="text"
                    class="py-2 pr-4 pl-10 border focus:border-red rounded-lg focus:ring-red w-full"
                    placeholder="{{ 'shop.searchPlaceholder' | translate }}"
                    (input)="searchTerm.set($any($event.target).value)"
                    [value]="searchTerm()"
                />
                <!-- clear -->
                @if (searchTerm() != "") {
                    <button
                        class="right-0 absolute inset-y-0 flex items-center pr-3 pointer-events-auto"
                        (click)="searchTerm.set('')"
                    >
                        <svg
                            class="w-4 h-4 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                }
            </div>

            <!-- Category Filter -->
            <div class="flex flex-col ~gap-1/2">
                <h3 class="font-semibold text-lg">
                    {{ "shop.categories" | translate }}
                </h3>
                <button
                    class="hover:bg-gray-200 rounded text-left transition-colors ~py-1/2 ~px-2/4"
                    (click)="handleCategoryClick(undefined)"
                    [class.bg-gray-200]="!selectedCategory()"
                >
                    {{ "shop.allCategories" | translate }}
                </button>
                @for (
                    category of data().categories;
                    track category.documentId
                ) {
                    <button
                        class="hover:bg-gray-200 rounded text-left transition-colors ~py-1/2 ~px-2/4"
                        (click)="handleCategoryClick(category)"
                        [class.bg-gray-200]="
                            selectedCategory()?.documentId ===
                            category.documentId
                        "
                    >
                        {{ category.name }}
                    </button>
                }
            </div>

            <!-- Price Filter -->
            <div class="flex flex-col justify-center gap-2 mb-2 w-full">
                <h3 class="font-semibold text-lg">
                    {{ "shop.priceRange" | translate }}
                </h3>

                <div class="flex items-center gap-2 text-sm">
                    <input
                        type="number"
                        class="py-1 border rounded-lg text-center ~w-12/16"
                        [(ngModel)]="minPrice"
                        onchange="this.value = Math.max(this.value, 0);"
                        placeholder="€ Min"
                    />
                    -
                    <input
                        type="number"
                        class="py-1 border rounded-lg text-center ~w-12/16"
                        [(ngModel)]="maxPrice"
                        onchange="this.value = Math.max(this.value, 0);"
                        placeholder="€ Max"
                    />
                </div>
            </div>
        </div>
    </div>

    <!-- sort by -->
    <div
        class="z-10 flex justify-between justify-self-end items-center lg:col-start-4 xl:col-start-5 w-full"
    >
        <select
            class="px-4 py-3 border border-primary rounded-lg w-full font-medium appearance-none"
            [(ngModel)]="sortOption"
            (change)="sortProducts()"
        >
            <option value="default" selected>
                {{ "shop.sortBy" | translate }}
            </option>
            <option value="name-asc">
                {{ "shop.sortByNameAsc" | translate }}
            </option>
            <option value="name-desc">
                {{ "shop.sortByNameDesc" | translate }}
            </option>
            <option value="price-asc">
                {{ "shop.sortByPriceAsc" | translate }}
            </option>
            <option value="price-desc">
                {{ "shop.sortByPriceDesc" | translate }}
            </option>
            <option value="newest">
                {{ "shop.sortByNewest" | translate }}
            </option>
            <option value="oldest">
                {{ "shop.sortByOldest" | translate }}
            </option>
        </select>
    </div>

    <!-- Products Grid -->
    <div
        class="col-span-1 sm:col-span-2 lg:col-span-3 xl:col-span-4"
        data-aos="fade-left"
        data-aos-delay="200"
    >
        <div
            class="gap-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        >
            @for (product of filteredProducts(); track product.documentId) {
                <app-product
                    (click)="shopService.lastViewedProduct = product"
                    id="{{ product.slug }}"
                    [product]="product"
                ></app-product>
            }
            @if (selectedCategoryHasVouchers()) {
                <div class="col-span-full py-12 text-center">
                    <p class="mb-4">
                        Gutscheine mit anderen Preisen können über das
                        Kontaktformular angefragt werden.
                    </p>
                    <a
                        [routerLink]="[
                            '/',
                            this.languageService.getLanguageCode,
                            'hof',
                            'kontakt',
                        ]"
                    >
                        <app-button>
                            {{ "contactYard.contact" | translate }}
                        </app-button>
                    </a>
                </div>
            }
            @if (filteredProducts().length === 0) {
                <div class="col-span-full py-12 text-gray-500 text-center">
                    {{ "shop.noProductsFound" | translate }}
                </div>
            }
        </div>
    </div>
</div>
